// Module
var code = "<p>Shopify related E-Commerce Development for luxury cashmere sweater brand - re-build Shopify theme from ground up utilizing ThemeKit. Managed integrations with third party APIs, coded custom checkout scripts for sale campaigns.</p>";
// Exports
export default code;